<template lang="pug">    
  v-card(   
    :style="`\
    background-image: url(${require('@/assets/spinwheel/bg3.png')});  \
    background-repeat: no-repeat, repeat; \
    background-size: cover; \
    background-position: center;\
    padding:100px;\
    `"
    @click="closeAfterFinish"
  )
    v-row(
      justify='center'
      align='center'
      style='position:relative;height:100%;'
      no-gutters
    )
      canvas(
        :width='breakPoint ? 500 : 250' 
        :height='breakPoint ? 500 : 250'
        :style="`\
      background-image: url(${require('@/assets/spinwheel/sw.png')});  \
      background-repeat: no-repeat, \
      repeat; background-size: cover;\
      position:absolute;`"
      )
      canvas#canvas( 
        :width='breakPoint ? 500 : 200'
        :height='breakPoint ? 500 : 200'
      )
      dialog-roulete-success(ref='dialogRouleteSuccess')

</template>
<script>
import { spinWheels as apiSpinwheels } from '@/apis'
import DialogRouleteSuccess from '@/components/Dialog/DialogRouleteSuccess'

export default { 
  components: {
    DialogRouleteSuccess
  },
  data: ()=>({
    isFinish:false,
    options:[],
    // options : [{name:'test1',s:false},{name:'test1',s:false},{name:'test1',s:false},{name:'test1',s:false},{name:'test1',s:false},{name:'test1',s:false},{name:'win',s:true}],
    imageUrlBlob: [],
    startAngle : 0, 
    spinTimeout : null, 
    spinTime:0,
    spinTimeTotal:0, 
    ctx:null,
    delayTime:15,
    spinAngleStop:0

  }),
  computed : {
    arc () {
      return Math.PI / (this.options.length / 2)
    },
    middleLength () {
      return Math.floor(this.options.length/2)
    },
    breakPoint () {
      return this.$vuetify.breakpoint.smAndUp
    },
  },

  async mounted (){     
    await this.load() 
    // this.startSpin()
  },

  methods:{
    closeAfterFinish () { 
      //check after finish spin
      if(this.isFinish) {
        this.$emit('close') 
      }
    },
    async load () {
      const [err,data]  = await apiSpinwheels.get()
      if(err) {
        this.$alert('',err,'warning') 
        this.$emit('close')
        return
      }

      if(data.length === 0){
        this.$emit('showDialog',false)
      } else { 
        this.options = data
        //preload image
        this.imageUrlBlob = data.map((x)=>{ 
          let image = new Image();   // create image
          image.src = x.image_url;      // set the src
          return image
          // return await fetch(x.image_url).then(r=>r.blob()).then(blobFile => new File([blobFile], "fileNameGoesHere", { type: "image/png" }))  
        }) 
        this.startSpin()  
      }
    }, 

    getColor (i) {
      return i%2 === 0 ? '#9BDFFF' : '#E0F5FF'
    },

    drawRouletteWheel () { 
      var canvas = document.getElementById("canvas"); 
      if (canvas.getContext("2d")) {
        
        const outsideRadius = this.breakPoint ? 200 : 100;
        const textRadius = this.breakPoint ? 160 : 80;
        const insideRadius = 0; 
        const width = this.breakPoint ? 250 : 100;
        const height = this.breakPoint ? 250 : 100;
        const imageX = this.breakPoint ? -25 :-10

        this.ctx = canvas.getContext("2d"); 
        this.ctx.clearRect(0,0,500,500); 

        this.ctx.strokeStyle = "black";
        this.ctx.lineWidth = 2; 
 
        this.ctx.font = 'bold 12px Helvetica, Arial'; 

        for(var i = 0; i < this.options.length; i++) {
          var angle = this.startAngle + i * this.arc; 
          this.ctx.fillStyle = this.getColor(i);

          this.ctx.beginPath();
          this.ctx.arc(width, height, outsideRadius, angle, angle + this.arc, false);
          this.ctx.arc(width, height, insideRadius, angle + this.arc, angle, true);
          this.ctx.stroke();
          this.ctx.fill();

          this.ctx.save();
          this.ctx.shadowOffsetX = -1;
          this.ctx.shadowOffsetY = -1;
          this.ctx.shadowBlur    = 0;
          this.ctx.shadowColor   = "rgb(220,220,220)";
          this.ctx.fillStyle = "black";
          this.ctx.translate(width + Math.cos(angle + this.arc / 2) * textRadius, 
                        height + Math.sin(angle + this.arc / 2) * textRadius);
          this.ctx.rotate(angle + this.arc / 2 + Math.PI / 2);
          var text = this.options[i].name;
          this.ctx.fillText(text, -this.ctx.measureText(text).width / 2, -5);

          // it's not preload
          // let base_image = new Image();
          // base_image.src = this.options[i].image_url 
          // base_image.src = "http://icons.iconarchive.com/icons/froyoshark/enkel/128/Telegram-icon.png"
          
          //circle image
          this.ctx.beginPath();
          // arc(x,y,radius,startAngle,StopEngle)
          this.ctx.arc(0,width/10, height/10, 0, Math.PI * 2, true);
          this.ctx.closePath();
          this.ctx.clip();

          // drawImage (url, x, y , width, height) ****  
          this.ctx.drawImage(this.imageUrlBlob[i],imageX, 0, width/5, height/5); 
          this.ctx.restore();
        } 

        // Arrow
        // this.ctx.fillStyle = "blue";
        // this.ctx.beginPath();
        // this.ctx.moveTo(width - 4, width - (outsideRadius + 5));
        // this.ctx.lineTo(width + 4, width - (outsideRadius + 5));
        // this.ctx.lineTo(width + 4, width - (outsideRadius - 5));
        // this.ctx.lineTo(width + 9, width - (outsideRadius - 5));
        // this.ctx.lineTo(width + 0, width - (outsideRadius - 60));
        // this.ctx.lineTo(width - 9, width - (outsideRadius - 5));
        // this.ctx.lineTo(width - 4, width - (outsideRadius - 5));
        // this.ctx.lineTo(width - 4, width - (outsideRadius + 5));
        // this.ctx.fill();  
      }
    },

    startSpin () { 
      const minimum_boudary = 3
      const angleRand = (Math.random() * ((this.arc * 180 / Math.PI)-minimum_boudary))  
      this.spinAngleStop = angleRand >= minimum_boudary ? angleRand : minimum_boudary 
      this.spinAngleStart = 10;  
      this.spinTime = 0;
      this.spinTimeTotal = 300 + Math.floor(Math.random()*100);
      this.rotateWheel();
    },

    rotateWheel () {   
      this.spinTime += 1;
      
      var degrees = this.startAngle * 180 / Math.PI + 90; 
      
      var arcd = this.arc * 180 / Math.PI;
      //back to solution
      var index = Math.floor((360 - degrees % 360) / arcd);    
      var spinAngle = this.spinAngleStart - 3 

      let current_degree_index = Math.floor((360 - degrees % 360) - (arcd*index))
      
      if(
        this.spinTime >= this.spinTimeTotal 
        && this.options[index].s
        && current_degree_index < this.spinAngleStop 
      ) {
        clearTimeout(this.spinTimeout);
        this.isFinish = true
        this.$nextTick(()=>{ 
          this.$refs.dialogRouleteSuccess.open(this.options[index])
        })
        return;
      }

      if(this.spinTime >= this.spinTimeTotal - 150 && index === this.middleLength ){
        this.delayTime += 1  
      } 

      this.startAngle += (spinAngle * Math.PI / 180);
      this.drawRouletteWheel();   
      this.spinTimeout = setTimeout(()=>this.rotateWheel(), this.delayTime);
    }, 
    
  }
}
</script>